import { IFormValue } from "./form-type";

export enum ChartType {
  // 正式图表类型
  BASIC_BAR = "BASIC_BAR", // 基础柱状图
  BASIC_PIE = "BASIC_PIE", // 基础饼图
  PIE_RING = "PIE_RING", // 环形图
  BASIC_LINE = "BASIC_LINE", // 基础折线图
  STACKED_COLUMN_BAR = "STACKED_COLUMN_BAR", // 堆叠柱状图
}

export enum Language {
  en = "en",
  zh = "zh",
}

export enum AppType {
  CHART = "CHART",
  AGGREGATE = "AGGREGATE",
}

export enum PageType {
  VIEW = "VIEW",
  EDIT = "EDIT",
}

export interface IQueryProps {
  workspaceId: string;
  tableId: string;
  locale: Language;
  // 实例id 目前是 block id
  blockId: string;
  // 是否具有权限
  hasPermission: boolean;
  // 是否为用 modal 展示 为 false 是 block block 可以出现在 dashboard 和 侧边栏 中
  isExpand: boolean;
  token: string;
  sessionId: string;
  form: PageType;
  index: number;
  shareUserId: string;
}

export enum ChartErrorType {
  // 饼图 扇形数量限制
  PIE_DIMENSION_COUNT_LIMIT = "PIE_DIMENSION_COUNT_LIMIT",
  // 部分字段失效 无法计算
  SOME_FIELDS_ARE_INVALID = "SOME_FIELDS_ARE_INVALID",
  // 关键字段没有选择 无法计算
  SOME_FIELDS_ARE_UNDEFINED = "SOME_FIELDS_ARE_UNDEFINED",
  // 计算结果中 没有数据 导致无法渲染 chart
  DATASET_IS_EMPTY_ARRAY = "DATASET_IS_EMPTY_ARRAY",
}

export interface IAppConfig {
  tableId: string;
  formValue: IFormValue;
}

export enum GlobalErrorType {
  // 没有 table 权限
  NOT_TABLE_PERMISSION = "NOT_TABLE_PERMISSION",
  // 请求失败 服务器错误
  SERVER_ERROR = "SERVER_ERROR",
  // 网络繁忙 请 稍后重试
  NETWORK_ERROR = "NETWORK_ERROR",
  // 请求失败 返回结果不合理
  RESPONSE_ERROR = "RESPONSE_ERROR",
}

export enum PostMessageEventName {
  // 主页面通知本页面 关闭 modal 并在关闭前做 form 是否保存的校验
  closeModalCheck = "closeModalCheck",
  // 通知 主页面 关闭modal
  closeModal = "closeModal",
  // 通知主页面 本页面准备完成 可以展示
  sendReadyStatus = "sendReadyStatus",
  // 更新 formValue 并重新计算 需要校验 isExpand 和 blockId
  refreshAppConfig = "refreshAppConfig",
  // 本页面通知主页面 指定 block 需要刷新  场景: modal 中 formValue 改变并提交服务器
  syncBlockAppConfig = "syncBlockAppConfig",
  // 主页面通知 刷新数据 并在刷新前进行 form 是否保存的校验
  refreshModalCheck = "refreshModalCheck",
  // 接收 client 推送的 TableData
  pushTableData = "pushTableData",
  // 接收 client 推送的 WorkspaceData
  pushWorkspaceData = "pushWorkspaceData",
  // 通知主页面 本页面准备好接收数据
  sendReadyForData = "sendReadyForData",
}

export interface PostMessageData {
  blockId?: string;
}

export interface IPostMessage {
  eventName: PostMessageEventName;
  // data 作为载荷的容器 应该是对象
  data?: PostMessageData | any;
}

export interface IBasicData {
  cellValue: any;
  value?: number;
  // 仅 单选 和 拆分选项值的多选 有该字段
  order?: number;
  [id: string]: any;
}
